class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    // Coming back from checkout via the browser Back button restores this
    // page from the back-forward cache WITHOUT re-running the fetch below, so
    // the drawer would still show the pre-checkout cart - e.g. a discount the
    // shopper removed at checkout would still look applied, with stale totals.
    // pageshow with persisted=true is exactly the bfcache-restore signal;
    // re-pull the live section then so totals and the coupon Apply/Remove
    // buttons both reflect the real cart. (A full page reload re-runs
    // connectedCallback anyway, so this only matters for the bfcache path.)
    this._onPageshow = (event) => {
      if (event.persisted) this.renderSection();
    };
    window.addEventListener('pageshow', this._onPageshow);
  }

  disconnectedCallback() {
    if (this._onPageshow) window.removeEventListener('pageshow', this._onPageshow);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.renderSection();
  }

  renderSection() {
    if (!this.dataset.url) return;

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    // ❌ REMOVE auto-open of cart drawer
     this.open();

    // ✅ Instead: show "Added to cart" toast
    // this.showToast();

    // 🔴 Auto-gift: ensure correct freebie after any mini-cart refresh
    if (window.__autoGift && typeof window.__autoGift.runNow === 'function') {
      window.__autoGift.runNow();
    }

    // Add-to-cart flows (product-form, swatches, gift-wrap) all funnel through
    // here but never fired cart:updated themselves - listeners elsewhere
    // (e.g. pdp-offers-for-you) would only catch up on the *next* unrelated
    // cart event without this, making them look permanently one step behind.
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: parsedState }
    }));
  }

  showToast() {
    const toast = document.querySelector('.cart-toast');
    if (!toast) return;

    toast.classList.add('cart-toast--visible');

    clearTimeout(this.toastTimeout);
    this.toastTimeout = setTimeout(() => {
      toast.classList.remove('cart-toast--visible');
    }, 3000);
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
